import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { VStack } from '@chakra-ui/react';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { ArticleListFeatured } from '@src/components/sco/Education/HomeLanding/Addons/ArticleListFeatured';
import { gql } from '@src/lib/gql';
import { useRouter } from 'next/navigation';
import React from 'react';
type ArticleFeaturedProps = {
  articleType: 'ExpertAdvice' | 'FounderStory' | 'BlogPost';
  typeTitle?: string;
  typeSlug?: string;
  carouselTitle?: string;
};
export const ArticleFeatured: React.FC<ArticleFeaturedProps> = props => {
  const $ = _c(15);
  useEducationContext();
  useRouter();
  const typeTitle = props.typeTitle || "Articles";
  const typeSlug = props.typeSlug || "articles";
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query ($type: ArticleType!) {
        articles(where: { type: $type }, orderBy: publishedAt_DESC) {
          id
          title
          seoDescription
          slug
          featuredImage {
            id
            url(transformation: { image: { resize: { fit: max, width: 1000 } } })
            altText
            height
            width
          }
          terms {
            id
            name
            slug
            color {
              hex
            }
          }
          subjectNames
          subjectLogos {
            id
            url
          }
        }
      }
    `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = props.articleType || "ExpertAdvice";
  let t2;
  if ($[1] !== t1) {
    t2 = {
      variables: {
        type: t1
      }
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const articleQuery = useQuery(t0, t2);
  let t3;
  if ($[3] !== articleQuery.error) {
    t3 = articleQuery.error && <p>{"Error: "}{articleQuery.error.message}</p>;
    $[3] = articleQuery.error;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== articleQuery.data?.articles) {
    t4 = articleQuery?.data?.articles || [];
    $[5] = articleQuery.data?.articles;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props.carouselTitle || $[8] !== t4 || $[9] !== typeSlug || $[10] !== typeTitle) {
    t5 = <ArticleListFeatured articles={t4} carouselTitle={props.carouselTitle} typeSlug={typeSlug} typeTitle={typeTitle} />;
    $[7] = props.carouselTitle;
    $[8] = t4;
    $[9] = typeSlug;
    $[10] = typeTitle;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <VStack align="stretch" justify="stretch" width="full">{t3}{t5}</VStack>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};